export default [
    // 1.
    {
        maxFlights: 1,
        flights: [
            [1],
        ],
    },
    // 2.
    {
        maxFlights: 1,
        flights: [
            [2],
        ],
    },
    // 3.
    {
        maxFlights: 1,
        flights: [
            [3],
        ],
    },
    // 4.
    {
        maxFlights: 1,
        flights: [
            [4],
        ],
    },
    // 5.
    {
        maxFlights: 2,
        flights: [
            [4, 1],
        ],
    },
    // 6.
    {
        maxFlights: 2,
        flights: [
            [4, 2],
        ],
    },
    // 7.
    {
        maxFlights: 2,
        flights: [
            [4, 3],
        ],
    },
    // 8.
    {
        maxFlights: 2,
        flights: [
            [4, 4],
        ],
    },
];
